export default __webpack_public_path__ + "static/media/01.69704d76.png";